import { render, staticRenderFns } from "./FormWrapper.vue?vue&type=template&id=668d863c&scoped=true"
import script from "./FormWrapper.vue?vue&type=script&lang=js"
export * from "./FormWrapper.vue?vue&type=script&lang=js"
import style0 from "./FormWrapper.vue?vue&type=style&index=0&id=668d863c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d863c",
  null
  
)

export default component.exports